<template>
    <right-filter-drawer
        v-model="showFilterDrawer"
        :title="title"
        :disable-apply="isFiltersEmpty || !isFormValid"
        :disable-clear="isFiltersEmpty"
        @cancel="onCancelFilters"
        @apply="onApplyFilters"
        @clear="onClearFilters"
    >
        <template v-slot:content>
            <v-form ref="form" v-model="isFormValid">
                <form-generator
                    v-model="localFilters"
                    :schema="schema"
                    value-class=""
                ></form-generator>
            </v-form>
        </template>
    </right-filter-drawer>
</template>

<script>
import FormLayout from '@/components/FormLayout/VerticalFormLayout';
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import RightFilterDrawer from '@/components/Drawers/RightFilterDrawer';
import filtersMixin from '@/mixins/filtersDrawerMixin';
import filtersSchema from './auditLogsFiltersSchema';
import { mapState } from 'vuex';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'AuditLogsFilters',
    components: {
        'form-generator': FormGenerator,
        'right-filter-drawer': RightFilterDrawer
    },
    mixins: [filtersMixin],
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => {}
        },
        title: {
            type: String,
            required: false,
            default: 'Audit Logs filters'
        }
    },
    computed: {
        ...mapState('auditLogs', ['eventMethodOptions']),
        schema() {
            const updatedSchema = [...filtersSchema];

            const methodField = updatedSchema.find(
                item => item.name === 'method'
            );
            methodField.component.props.items = this.eventMethodOptions;

            return updatedSchema;
        }
    }
};
</script>

<style></style>
